export enum LanguageSkillLevel {
  Fluent = "Fluent",
  Good = "Good",
  OK = "OK"
}
